
/**
 * 维保报告详细信息
 */

import React, { Component } from 'react';

import { Modal, Button } from 'antd';
import '../../../style/ui/maintenance.css';

import { formatDate } from '../../../util/util';

class MaintenanceReport extends Component {


    trandformRes = (res) => {
        if (res.report.lastMaintenanceTime !== '' && res.report.lastMaintenanceTime !== null) {
            res.report.lastMaintenanceTime = formatDate(res.report.lastMaintenanceTime);
        }
        if (res.report.lastRepTime !== '') {
            res.report.lastRepTime = formatDate(res.report.lastRepTime);
        }
        // 历史里程时间戳转换
        let mileageBaseInfos = res.report.mileageInfo.MileageBaseInfos;
        for (let i = 0; i < mileageBaseInfos.length; i++) {
            mileageBaseInfos[i].date = formatDate(mileageBaseInfos[i].date);
        }
        res.report.mileageInfo.MileageBaseInfos = mileageBaseInfos;

        //保养时间戳转换
        let recordsMaintenance = res.report.recordsMaintenance;
        for (let i = 0; i < recordsMaintenance.length; i++) {
            recordsMaintenance[i].repairBeginDate = formatDate(recordsMaintenance[i].repairBeginDate);
        }
        res.report.recordsMaintenance = this.trandformListData(recordsMaintenance);
        res.report.scoreCarWater = Number(res.report.scoreCarWater);
        // vin码隐藏中间部分值
        res.report.vinStr = res.report.vin.replace(res.report.vin.substring(3, 13), "*********");

        //最后保养时间、记录时间转换 
        res.report.lastMaintenanceTime = formatDate(res.report.lastMaintenanceTime);
        res.report.lastRepTime = formatDate(res.report.lastRepTime);

        // 维保数据时间转换，更换材料、项目描述字符拼接
        let recordsRep = res.report.recordsRep;
        if (recordsRep.length !== 0) {
            recordsRep = this.trandformListData(res.report.recordsRep);
        }

        // 火烧排查
        if (res.report.carFire.length !== 0) {
            res.report.carFire = this.trandformKeyData(res.report.carFire);
        }
        // 泡水排查
        if (res.report.carWater.length !== 0) {
            res.report.carWater = this.trandformKeyData(res.report.carWater);
        }

        // 发动机/变速箱
        if (res.report.carEngineAndGearbox.length !== 0) {
            res.report.carEngineAndGearbox = this.trandformKeyData(res.report.carEngineAndGearbox);
        }
        // 重要组成部件
        if (res.report.carComponent.length !== 0) {
            res.report.carComponent = this.trandformKeyData(res.report.carComponent);
        }
        // 车身外观
        if (res.report.carOutSide.length !== 0) {
            res.report.carOutSide = this.trandformKeyData(res.report.carOutSide);
        }

        // 其他维修
        if (res.report.recordsRepair.length !== 0) {
            res.report.recordsRepair = this.trandformListData(res.report.recordsRepair);
        }

        // 碰撞数据
        if (res.report.recordsIns.length !== 0) {
            res.report.recordsIns = this.trandformListData(res.report.recordsIns);
        }

        return res;
    }

    // 转换数据格式
    trandformListData = (data) => {
        for (let i = 0; i < data.length; i++) {
            let materialStr = '';
            let recordItemsStr = '';
            data[i].repairBeginDate = formatDate(data[i].repairBeginDate);
            if (typeof (data[i].material) === 'string') {
                data[i].material = JSON.parse(data[i].material);
            }
            // 更换材料
            if (data[i].material.length !== 0) {
                for (let j = 0; j < data[i].material.length; j++) {
                    materialStr += data[i].material[j].name + ":" + data[i].material[j].count +
                        ";"
                }
                data[i].materialStr = materialStr
            }
            // 项目描述
            if (data[i].recordItems.length !== 0) {
                for (let j = 0; j < data[i].recordItems.length; j++) {
                    recordItemsStr += data[i].recordItems[j].description + ";"
                }
                data[i].recordItemsStr = recordItemsStr
            }
        }
        return data;
    }
    trandformKeyData = (data) => {
        for (let i = 0; i < data.length; i++) {
            let materialStr = '';
            let recordItemsStr = '';
            if (data[i].repairRecord != null) {
                data[i].repairRecord.repairBeginDate = formatDate(data[i].repairRecord.repairBeginDate);
                if (typeof (data[i].repairRecord.material) === 'string') {
                    data[i].repairRecord.material = JSON.parse(data[i].repairRecord.material);
                }
                // 更换材料
                if (data[i].repairRecord.material.length !== 0) {
                    for (let j = 0; j < data[i].repairRecord.material.length; j++) {
                        materialStr += data[i].repairRecord.material[j].name + ":" + data[i].repairRecord.material[j].count +
                            ";"
                    }
                    data[i].repairRecord.materialStr = materialStr;
                }
                // 项目描述
                if (data[i].repairRecord.recordItems.length !== 0) {
                    for (let j = 0; j < data[i].repairRecord.recordItems.length; j++) {
                        recordItemsStr += data[i].repairRecord.recordItems[j].description + ";"
                    }
                    data[i].repairRecord.recordItemsStr = recordItemsStr;
                }
            }
        }
        return data
    }
    // 维修时间排序
    carmodelCompare(pro) {
        return function (obj1, obj2) {
            var val1 = obj1[pro];
            var val2 = obj2[pro];
            if (val1 < val2) { //倒序
                return 1;
            } else if (val1 > val2) {
                return -1;
            } else {
                return 0;
            }
        }
    }
    getString=(str,op)=>{
        var i = str.indexOf('<li>'+op);
        var data=str.substring(i,str.length);
        var j = data.indexOf('span')+5;
        var k = data.indexOf('/span')-1;
        var datas = data.substring(j,k);
        return datas;
    }
    render() {
        const { visible, onCancel, editData } = this.props;
        let  pcHtml = editData.pcHtml;

        let data = {};
        let otherList = [];
        let vehicleInfo = {}
        if (editData && JSON.stringify(editData) !== "{}") {
            data = this.trandformRes(editData)
            otherList = otherList.concat(data.report.recordsIns);
            otherList = otherList.concat(data.report.recordsMaintenance);
            otherList = otherList.concat(data.report.recordsRep);
            otherList = otherList.concat(data.report.recordsRepair);
            otherList = otherList.sort(this.carmodelCompare('repairBeginDate'));
            otherList.reverse()
            vehicleInfo.vin = this.getString(pcHtml,'VIN码')
            vehicleInfo.producter = this.getString(pcHtml,'生产厂商')
            vehicleInfo.productDate = this.getString(pcHtml,'生产年份')
            vehicleInfo.location = this.getString(pcHtml,'产地')
            vehicleInfo.carType = this.getString(pcHtml,'车辆类型')
            vehicleInfo.gearType = this.getString(pcHtml,'变速箱类型')
            vehicleInfo.displacement = this.getString(pcHtml,'排量')
            vehicleInfo.emissionStandard = this.getString(pcHtml,'排放标准')
        }
        return (
            <Modal
                width={1400}
                visible={visible}
                title="车辆维保详情"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                zIndex={1000}
                footer={[
                    <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                ]}
            >
        
                <div className="wrap">
                    <div className="carname">
                        <p className="name updateStatus">{data.brand}</p>
                        <p> 报告生成时间：<span>{data.reportTime}</span>
                        </p>
                    </div>
                    <div className="cartype">
                        <ul className="cartype_list cf">
                            <li>VIN码 <span>{vehicleInfo.vin?vehicleInfo.vin:'--'}</span></li>
                            <li>生产厂商<span>{vehicleInfo.producter?vehicleInfo.producter:'--'}</span></li>
                            <li>生产年份<span>{vehicleInfo.productDate?vehicleInfo.productDate:'--'}</span></li>
                            <li>产地 <span>{vehicleInfo.location?vehicleInfo.location:'--'}</span></li>
                            <li>车辆类型<span>{vehicleInfo.carType?vehicleInfo.carType:'--'}</span></li>
                            <li>变速箱类型<span>{vehicleInfo.gearType?vehicleInfo.gearType:'--'}</span></li>
                            <li>排量 <span>{vehicleInfo.displacement?vehicleInfo.displacement:'--'}</span></li>
                            <li>排放标准<span>{vehicleInfo.emissionStandard?vehicleInfo.emissionStandard:'--'}</span></li>
                        </ul>
                    </div>
                    {
                        data.report ?
                            <div className="report_box">
                                <p className="name">报告概要</p>
                                <ul className="report_type">
                                    <li>
                                        <div className="type"><i></i>事故分析</div>
                                        <p className="">
                                            疑似火烧维修记录：<label>{data.report.carFire.length !== 0 ? data.report.carFire.length : '无'}</label>
                                        </p>
                                        <p> 疑似水泡维修记录： <label>{data.report.carWater.length !== 0 ? data.report.carWater.length : '无'}</label> </p>
                                    </li>
                                    <li>
                                        <div className="type"><i className="col_f8e71c"></i>车况分析</div>
                                        <p className="">
                                            重要组成部件维修记录：<label className="pointer">{data.report.carComponent.length !== 0 ? data.report.carComponent.length : '无'}</label>
                                        </p>
                                        <p> 外观覆盖件维修记录： <label className="pointer1">{data.report.scoreCarOutside.length !== 0 ? data.report.scoreCarOutside.length : '无'}</label> </p>
                                    </li>
                                    <li>
                                        <div className="type"><i className="col_bd10e0"></i>里程分析</div>
                                        <p className=""> 里程表记录： <label>{data.report.mileageInfo.ErrorMileageTimes === 0 ? '正常' : '异常'}
                                        </label> </p>
                                        <p className=""> 最后公里数：<label>{data.report.mileageInfo.TraveledMileage}公里 </label> 预估至今公里数：<label> {data.report.mileageInfo.ExpectMileage}公里 </label> </p>
                                    </li>
                                    <li>
                                        <div className="type"><i className="col_417505"></i>车主爱惜度</div>
                                        <p className=""> 最后一次保养时间：<label>{data.report.lastMaintenanceTime} </label> 年平均保养次数：<label>{data.report.avgYearMaintenanceTimes}次/年 </label> </p>
                                        <p> 最后一次进店时间：<label> {data.report.lastRepTime}</label> 年平均行驶里程：<label>{data.report.avgYearMileage}公里/年 </label> </p>
                                    </li>
                                </ul>
                            </div> : ''

                    }
                    {/* <!--事故,车况，里程，车主爱惜度，普通报告--> */}
                    {data.report ? <div className="report_tab">
                        <div className="tab_div">
                            <div id="tab" className="tab_wrap cf">
                                <p className="name"><i></i>事故分析
                                {/* <label><span></span>解析规则</label> */}
                                </p>
                                {
                                    data.report.carFire.length !== 0 && data.report.carWater.length !== 0 ?
                                        <div className="table_box">
                                            <table>
                                                <tbody>
                                                    <tr className="table_tit" >
                                                        <th style={{ width: '160', textAlign: 'center' }}>日期</th>
                                                        <th style={{ width: "160", textAlign: 'center' }}>公里数</th>
                                                        <th style={{ width: "240", textAlign: 'center' }}>维修类型</th>
                                                        <th style={{ width: "654" }}>内容</th>
                                                    </tr>
                                                    {
                                                        data.report.carFire.map((item, index) => {
                                                            return <tr className="table_cent" key={index} >
                                                                <td style={{ width: '160', textAlign: 'center' }}>{item.repairRecord.repairBeginDate}</td>
                                                                <td style={{ width: '160', textAlign: 'center' }}>{item.repairRecord.mileage} </td>
                                                                <td style={{ width: '240', textAlign: 'center' }}>
                                                                    <div style={{ width: '130', padding: "0 10px", wordBreak: ' break-all' }}>{item.repairRecord.repairType}</div>
                                                                </td>
                                                                <td style={{ width: '654' }}>
                                                                    <div className="tet">项目：{item.repairRecord.recordItemsStr}<br />材料： {item.repairRecord.materialStr} </div>
                                                                </td>
                                                            </tr>
                                                        })
                                                    }
                                                    {
                                                        data.report.carWater.map((item, index) => {
                                                            return <tr className="table_cent" key={index} >
                                                                <td style={{ textAlign: 'center', width: '160' }}>{item.repairRecord.repairBeginDate}</td>
                                                                <td style={{ textAlign: 'center', width: '160' }}>{item.repairRecord.mileage} </td>
                                                                <td style={{ textAlign: 'center', width: '240' }}>
                                                                    <div style={{ width: '130', padding: "0 10px", wordBreak: ' break-all' }}>{item.repairRecord.repairType}</div>
                                                                </td>
                                                                <td style={{ width: '654' }}>
                                                                    <div className="tet">项目：{item.repairRecord.recordItemsStr}<br />材料： {item.repairRecord.materialStr} </div>
                                                                </td>
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div> : <div style={{ textAlign: 'center', color: '#ccc' }}>暂无记录</div>
                                }
                            </div>
                            {/* <!--车况分析--> */}
                            <div id="tab1" className="tab_wrap marg10 cf">
                                <p className="name">
                                    <i className="col_f8e71c"></i>车况分析
                                    {/* <label ><span></span>解析规则</label> */}
                                </p>
                                {
                                    data.report.carOutSide.length !== 0 ?
                                        <div className="table_box">
                                            <table>
                                                <tbody>
                                                    <tr className="table_tit" >
                                                        <th style={{ textAlign: 'center', width: '160' }}>日期</th>
                                                        <th style={{ textAlign: 'center', width: '160' }}>公里数</th>
                                                        <th style={{ textAlign: 'center', width: '240' }}>维修类型</th>
                                                        <th style={{ width: '654' }}>内容</th>
                                                    </tr>
                                                    {
                                                        data.report.carOutSide.map((item, index) => {
                                                            return <tr className="table_cent" key={index} >
                                                                <td style={{ textAlign: 'center', width: '160' }}>{item.repairRecord.repairBeginDate}</td>
                                                                <td style={{ textAlign: 'center', width: '160' }}>{item.repairRecord.mileage} </td>
                                                                <td style={{ textAlign: 'center', width: '240' }}>
                                                                    <div style={{ width: '130', padding: "0 10px", wordBreak: ' break-all' }}>{item.repairRecord.repairType}</div>
                                                                </td>
                                                                <td style={{ width: '654' }}>
                                                                    <div className="tet">项目：{item.repairRecord.recordItemsStr}<br />材料： {item.repairRecord.materialStr} </div>
                                                                </td>
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div> : <div style={{ textAlign: 'center', color: '#ccc' }}>暂无记录</div>
                                }
                            </div>


                            {/* <!--车主爱惜度--> */}
                            <div id="tab3" className="tab_wrap marg10">
                                <p className="name"><i className="tab_ipos col_417505"></i>车主爱惜度</p>
                                <ul className="list_time">
                                    <li> <label>最后一次保养时间：</label> <span>{data.report.lastMaintenanceTime}</span> </li>
                                    <li> <label>年平均保养次数：</label> <span> {data.report.avgYearMaintenanceTimes}次/年 </span> </li>
                                    <li> <label>最后一次进店时间：</label> <span> {data.report.lastRepTime}</span> </li>
                                    <li> <label>年平均行驶里程：</label> <span> <span style={{ float: 'left' }}>{data.report.avgYearMileage}公里/年</span> </span> </li>
                                </ul>
                            </div>

                            {/* <!--普通报告--> */}
                            <div id="tab1" className="tab_wrap marg10 cf">
                                <p className="name">
                                    <i className="col_f8e71c"></i>其他维修
                                    {/* <label ><span></span>解析规则</label> */}
                                </p>
                                {
                                    otherList.length !== 0 ?
                                        <div className="table_box">
                                            <table>
                                                <tbody>
                                                    <tr className="table_tit" >
                                                        <th width='160' style={{ textAlign: 'center' }}>日期</th>
                                                        <th width='160' style={{ textAlign: 'center' }}>公里数</th>
                                                        <th width='180' style={{ textAlign: 'center' }}>维修类型</th>
                                                        <th style={{ width: '654' }}>内容</th>
                                                    </tr>
                                                    {
                                                        otherList.map((item, index) => {
                                                            return <tr className="table_cent" key={index} >
                                                                <td width='160' style={{ textAlign: 'center' }}>{item.repairBeginDate}</td>
                                                                <td width='160' style={{ textAlign: 'center' }}>{item.mileage} </td>
                                                                <td width='180' style={{ textAlign: 'center' }}>
                                                                    <div style={{ width: '130', padding: "0 10px", wordBreak: ' break-all' }}>{item.repairType}</div>
                                                                </td>
                                                                <td style={{ width: '654' }}>
                                                                    <div className="tet">项目：{item.recordItemsStr}<br />材料： {item.materialStr} </div>
                                                                </td>
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div> : <div style={{ textAlign: 'center', color: '#ccc' }}>暂无记录</div>
                                }
                            </div>

                        </div>
                    </div> : ''
                    }
                </div>

                {/* <div dangerouslySetInnerHTML={{ __html: editData.pcHtml }} /> */}

            </Modal>

        );
    }
}

export default MaintenanceReport;